import { getCookie, setCookie } from './cookies';

// Stable per-browser-install device id for the login device list (MAX 10 devices).
// Created once and kept in BOTH localStorage and a 5-year cookie, so clearing one
// store alone doesn't mint a "new device". Sent as X-Device-Id on every request;
// the backend uses it ONLY to collapse re-logins from the same device into one
// UserSession row (the hardware fingerprint drifts with monitor/font changes).
// NOT a security or abuse signal.

const KEY = 'sk_device_id';
const VALID = /^[A-Za-z0-9_-]{8,64}$/;

let cached = null;

export function getDeviceId() {
    if (cached) return cached;

    let id = null;
    try { id = localStorage.getItem(KEY); } catch { /* storage blocked */ }
    if (!id || !VALID.test(id)) id = getCookie(KEY);
    if (!id || !VALID.test(id)) {
        id = (typeof crypto !== 'undefined' && crypto.randomUUID)
            ? crypto.randomUUID()
            : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
    }

    // Re-persist to both stores every time so a cleared store gets healed.
    try { localStorage.setItem(KEY, id); } catch { /* ignore */ }
    try { setCookie(KEY, id, { days: 365 * 5 }); } catch { /* ignore */ }

    cached = id;
    return id;
}

export default getDeviceId;
